import { useSelector } from "react-redux";

const useMyProfile = () => {
    const myProfile = useSelector((state) => state.myProfile);

    return myProfile;
};

export default useMyProfile;